<template>
  <DeliveryAvailabilityMail
    class="delivery-availability-mail-container"
    :success="success"
  >
    <template #content>
      <p class="delivery-availability-mail-container__description">
        {{ content.copy }}
        <button
          class="btn btn--footnote"
          aria-label="Fußnote"
          @click="clickOpenModal()"
        >
          *
        </button>
      </p>
    </template>
    <FormErrorList
      ref="fehler"
      class="delivery-availability-mail-container__errors"
      :errors="parsedErrors"
    />
    <div class="delivery-availability-mail-container__controls">
      <TextInput
        ref="daten"
        v-model="fields.values.email"
        class="delivery-availability-mail-container__input"
        :label="emailLabel"
        id-prefix="email"
        :error-message="fields.errors.email?.[0]"
        required
        :disabled="!isEditable"
        :placeholder="emailPlaceholder"
      />
      <button
        type="submit"
        class="btn btn--primary customer-data-form__btn delivery-availability-mail-container__button"
        :disabled="!isSubmittable"
        :data-tealium-rel="tealiumRel"
        @click.prevent="submit"
      >
        {{ buttonLabel }}
      </button>
    </div>
  </DeliveryAvailabilityMail>
</template>

<script>
import ShopApi from '~/lib/shop-api';
import { openModal } from '~/composables/modal';
import { getErrorMessages } from '~/lib/error-parser';
import FormErrorList from '~/components/form-error-list.vue';
import { DeliveryAvailabilityMail, TextInput } from '@i22/td-longtail-vue-components';
import Form from '~/mixins/form';
import { tealiumLink } from '~/lib/tealium';

export default {
  name: 'DeliveryAvailabilityMailContainer',
  components: {
    FormErrorList,
    TextInput,
    DeliveryAvailabilityMail,
  },
  mixins: [
    Form({
      email: true,
    }),
  ],
  props: {
    articleNumber: { type: String, required: true },
    emailLabel: { type: String, default: 'E-Mail-Adresse' },
    tealiumSuffix: { type: String, default: null },
    emailPlaceholder: { type: String, default: '' },
    buttonLabel: { type: String, default: 'Nachricht erhalten' },
  },
  data() {
    return {
      parsedErrors: {},
      success: false,
      legalText: [
        'In dem Zusammenhang speichern wir ausschließlich Deine E-Mail-Adresse. Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. f der Datenschutz-Grundverordnung. Die Daten werden ausschließlich in Deutschland verarbeitet.',
        'Die Löschung der Daten erfolgt nach spätestens 6 Monaten. Eine Nutzung der Daten für einen anderen als den vorgenannten Verwendungszweck oder eine Übermittlung an sonstige Dritte findet seitens der Telekom nur statt, sofern dies gesetzlich zulässig ist oder Du ausdrücklich eingewilligt hast.',
      ],
      content: {
        copy: 'Als Erstes informiert werden, sobald das Produkt (auch außerhalb eines möglichen Aktionszeitraums) wieder verfügbar ist – bitte E-Mail-Adresse hinterlegen:',
        button: {
          label: 'Nachricht erhalten',
        },
      },
    };
  },
  computed: {
    tealiumRel() {
      return this.tealiumSuffix
        ? `content.button.nachricht-erhalten.${this.tealiumSuffix}`
        : 'content.button.nachricht-erhalten';
    },
  },
  methods: {
    clickOpenModal() {
      openModal({
        content: this.legalText.map((t) => `<p>${t}</p>`).join(''),
      });
    },
    async submit() {
      tealiumLink({
        wt_link_id: this.tealiumRel,
      });
      try {
        const subscription = {
          articleNumber: this.articleNumber,
          email: this.fields.values.email,
        };
        await ShopApi.availabilitySubscriptions(subscription);
        this.success = true;
      } catch (e) {
        const { errors } = e.data;
        this.parsedErrors = getErrorMessages(errors);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.delivery-availability-mail-container {
  max-width: 530px;

  &__description,
  &__input,
  &__button {
    margin-bottom: $grid-base * 2;
  }
  &__errors {
    padding: 0;
  }
  &--success {
    padding-bottom: $grid-base * 2;
    padding-top: $grid-base * 2;
    width: 100%;
  }

  &__button {
    @include mq($mq-sm) {
      margin-left: $grid-base * 2;
    }
  }

  &__input {
    width: 100%;
  }

  &__controls {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    @include mq($mq-sm) {
      flex-direction: row;
      align-items: flex-end;
    }
  }
}
</style>
